module.exports = __webpack_public_path__ + "img/電気回路_3_6_4.d7da36cd.png";